import React from 'react';

// Slate wordmark for the desktop row header. Exported from Figma, optimized with
// SVGO; fill uses currentColor (.logoLink). Decorative — the wrapping link carries
// aria-label="Slate Home".
const SlateLogoDesktop: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    viewBox="0 0 163 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#a)">
    <path fill="currentColor" d="M135.37 21.41h27.435V16.06h-16.203v-2.584h16.203V8.31h-16.203V5.725h16.203V.377H135.37zm-25.869 0h11.235V5.724h9.819V.377H99.686v5.348h9.819v15.684zm-32.377-9.736 1.293-5.949h4.97l1.293 5.95h-7.56zM63.393 21.41h11.595l.964-4.448h9.906l.963 4.448h11.654L93.083.377H68.779l-5.391 21.032zm-30.056 0h25.628v-5.348H44.567V.377H33.332v21.032zm-11.112 0H0v-5.348h17.017V13.57H6.024C2.26 13.569 0 11.226 0 8.221V5.729C0 2.724 2.26.38 6.024.38h22.224v5.348H11.231V8.22h10.993c3.764 0 6.024 2.343 6.024 5.348v2.492c0 3.005-2.26 5.348-6.024 5.348"/>
    </g>
    <defs>
    <clipPath id="a">
    <path fill="#fff" d="M0 0h163v21.783H0z"/>
    </clipPath>
    </defs>
  </svg>
);

export default SlateLogoDesktop;
